import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { profileData } from '../data/profile.data';
import { ProfileService } from '@app/modules/profile/services/profile.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileInterceptor implements HttpInterceptor {
  constructor() {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return profileBackend(req.url, req.method) || next.handle(req);
  }
}

export function profileBackend(url: string, method: string): Observable<HttpEvent<any>> {

  if (!url.startsWith(ProfileService.API_PROFILE_BASE_PATH)) {
    return null;
  }
  // Users call
  switch (method) {
    case 'GET':
      return new Observable(response => {
        response.next(new HttpResponse<any>({
          status: 200,
          body: profileData
        }));
        response.complete();
      });
  }

}
